export default "__VITE_ASSET__BjNwsCvh__"